import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { getAdminDashboard } from "../../../../services/operations/adminAPI"

//One tile of the overview grid
const StatCard = ({ label, value }) => {
  return (
    <div className="flex flex-col gap-y-1 rounded-md bg-richblack-800 p-6">
      <p className="text-sm font-medium text-richblack-300">{label}</p>
      <p className="text-3xl font-semibold text-richblack-5">{value}</p>
    </div>
  )
}

const AdminDashboard = () => {
  const { token } = useSelector((state) => state.auth)
  const { user } = useSelector((state) => state.profile)

  const [loading, setLoading] = useState(false)
  const [stats, setStats] = useState(null)

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      const data = await getAdminDashboard(token)
      setStats(data)
      setLoading(false)
    })()
  }, [token])

  if (loading) {
    return <div className="spinner"></div>
  }

  return (
    <div>
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-richblack-5">
          Hi {user?.firstName} 👋
        </h1>

        <p className="font-medium text-richblack-200">
          Here is how the platform is doing
        </p>
      </div>

      {!stats ? (
        <p className="mt-10 text-center text-xl font-medium text-richblack-100">
          No data to show yet
        </p>
      ) : (
        <>
          <div className="my-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <StatCard label="Students" value={stats.totalStudents} />
            <StatCard label="Instructors" value={stats.totalInstructors} />
            <StatCard label="Categories" value={stats.totalCategories} />
            <StatCard
              label="Courses"
              value={`${stats.publishedCourses} / ${stats.totalCourses}`}
            />
            <StatCard label="Total Enrolments" value={stats.totalEnrolments} />
            <StatCard
              label="Total Revenue"
              value={`Rs. ${stats.totalRevenue}`}
            />
          </div>

          <p className="mb-6 text-sm text-richblack-300">
            Courses shows published out of total.
          </p>

          <Link
            to="/dashboard/categories"
            className="rounded-md bg-yellow-50 px-5 py-2 font-semibold text-richblack-900"
          >
            Manage categories
          </Link>
        </>
      )}
    </div>
  )
}

export default AdminDashboard
